import React from 'react';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import Card from '../ui/card';
import StatsZonesChart from './statsZones-chart';
import StatsGatesPieChart from './statsGatesPie-chart';
import StatsGateXYChart from './statsGatesXY-chart';
import StatsTerminalsPieChart from './statsTerminalsPie-chart';
import StatsTerminalsXYChart from './statsTerminalsXY-chart';
import StatsTerminalsXYStackChart from './statsTerminalsXY-stack-chart';
var t = i18n.getFixedT(null, 'stats-dashboard');
var StatsDashboardInfo = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      _useSelector$statsDas = _useSelector.statsDashboard,
      statsZones = _useSelector$statsDas.statsZones,
      statsGatesForPie = _useSelector$statsDas.statsGatesForPie,
      statsGatesForXY = _useSelector$statsDas.statsGatesForXY,
      statsTerminalsForPie = _useSelector$statsDas.statsTerminalsForPie,
      statsTerminalsForXY = _useSelector$statsDas.statsTerminalsForXY,
      statsTerminalsDelivery = _useSelector$statsDas.statsTerminalsDelivery;

  var currentTab = props.currentTab;
  var cardTypes = {
    gate: [{
      key: 'statsZones',
      title: t('lbl-zones-stats-analysis')
    }, {
      key: 'statsGatesPie',
      title: t('lbl-gates-stats-perscent')
    }, {
      key: 'gatesStatsXY',
      title: t('lbl-gates-inout-stats')
    }],
    terminal: [{
      key: 'statsTerminals',
      title: t('lbl-terminals-inout-perscent')
    }, {
      key: 'statsTerminalsXY',
      title: t('lbl-terminals-inout-stats')
    }, {
      key: 'statsTerminalsDelivery',
      title: t('lbl-terminals-deliver-receive-stats')
    }]
  };

  var renderWaittingComponent = function renderWaittingComponent(data, dom) {
    if (_.isEmpty(data)) {
      return /*#__PURE__*/React.createElement("div", {
        className: "loading"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-circle-notch fa-spin fa-3x fa-fw"
      }));
    }

    return dom;
  };

  var renderContent = function renderContent(key) {
    switch (key) {
      case 'statsZones':
        return renderWaittingComponent(statsZones, /*#__PURE__*/React.createElement(StatsZonesChart, null));

      case 'statsGatesPie':
        return renderWaittingComponent(statsGatesForPie, /*#__PURE__*/React.createElement(StatsGatesPieChart, null));

      case 'gatesStatsXY':
        return renderWaittingComponent(statsGatesForXY, /*#__PURE__*/React.createElement(StatsGateXYChart, null));

      case 'statsTerminals':
        return renderWaittingComponent(statsTerminalsForPie, /*#__PURE__*/React.createElement(StatsTerminalsPieChart, null));

      case 'statsTerminalsXY':
        return renderWaittingComponent(statsTerminalsForXY, /*#__PURE__*/React.createElement(StatsTerminalsXYChart, null));

      case 'statsTerminalsDelivery':
        return renderWaittingComponent(statsTerminalsDelivery, /*#__PURE__*/React.createElement(StatsTerminalsXYStackChart, null));

      default:
        return 'no data';
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "statsDashboard-info"
  }, _.map(cardTypes[currentTab], function (el) {
    return /*#__PURE__*/React.createElement(Card, {
      key: el.key,
      title: el.title,
      enableFullScreen: true
    }, renderContent(el.key));
  }));
});
export default StatsDashboardInfo;